module.exports = __webpack_public_path__ + "img/Raghavendra.cb70a6de.jpg";